// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Config$LiveRoom from "../../../Config.bs.js";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as CommonStyles$LiveRoom from "../../styles/CommonStyles.bs.js";
import * as AuthTokenHook$LiveRoom from "../../stores/AuthTokenHook.bs.js";
import * as SterlingIcons$LiveRoom from "../../bindings/SterlingIcons.bs.js";
import * as SterlingModal$LiveRoom from "../../bindings/SterlingModal.bs.js";
import * as SterlingTokens$LiveRoom from "../../bindings/SterlingTokens.bs.js";
import * as Button from "@sothebys/sterling/button";
import * as SterlingTypography$LiveRoom from "../../bindings/SterlingTypography.bs.js";
import * as AuctionRoomSharedContacts$LiveRoom from "../AuctionRoomSharedContacts.bs.js";

function SubmitIdentificationModal$Pending$EmailInfoClicker(props) {
  var info = props.info;
  var text = props.text;
  var text$1 = text !== undefined ? text : "";
  var link = "mailto:" + info;
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.display("flex"),
                    tl: {
                      hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryNavy100_nohashtag)),
                      tl: /* [] */0
                    }
                  })
            }, React.createElement("div", {
                  className: Curry._1(Css.style, {
                        hd: Css.marginRight(Css.px(10)),
                        tl: /* [] */0
                      })
                }, React.createElement(SterlingIcons$LiveRoom.Collection.Email24.make, {})), React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
                  children: React.createElement("a", {
                        className: Curry._1(Css.style, {
                              hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryNavy100_nohashtag)),
                              tl: {
                                hd: Css.textDecoration("none"),
                                tl: /* [] */0
                              }
                            }),
                        href: link
                      }, "" + text$1 + " " + info + "")
                }));
}

var EmailInfoClicker = {
  make: SubmitIdentificationModal$Pending$EmailInfoClicker
};

function SubmitIdentificationModal$Pending(props) {
  var onClose = props.onClose;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  var bidsDepartmentEmails = Belt_Array.map([
        /* NewYorkAuction */0,
        /* LondonAuction */1,
        /* ParisAuction */4,
        /* HongKongAuction */3,
        /* MilanAuction */5,
        /* GenevaAuction */2
      ], (function ($$location) {
          return AuctionRoomSharedContacts$LiveRoom.getEmailAndPhoneByAuctionLocation($$location)[0];
        }));
  return React.createElement(SterlingModal$LiveRoom.Modal.make, {
              children: null,
              className: Curry._1(Css.style, {
                    hd: Css.important(Css.maxHeight(Css.pct(100))),
                    tl: /* [] */0
                  }),
              headerClassName: Curry._1(Css.style, {
                    hd: CommonStyles$LiveRoom.mediaV2(/* DesktopAndTabletLandscape */4, {
                          hd: Css.paddingBottom(Css.px(0)),
                          tl: /* [] */0
                        }),
                    tl: /* [] */0
                  }),
              onClose: onClose,
              isOpen: true,
              headerTitle: Curry._1(t, "SubmitIdentification_UnableToVerify")
            }, React.createElement(SterlingModal$LiveRoom.Content.make, {
                  children: null
                }, React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
                      children: Curry._1(t, "SubmitIdentification_UnableToVerifyInformation")
                    }), React.createElement("div", {
                      className: Curry._1(Css.style, {
                            hd: Css.padding2(Css.px(40), "zero"),
                            tl: /* [] */0
                          })
                    }, React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
                          children: Curry._1(t, "SubmitIdentification_InformationNeedsFurtherReview")
                        }), React.createElement("br", undefined), React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
                          className: Curry._1(Css.style, {
                                hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                                      hd: Css.display("none"),
                                      tl: /* [] */0
                                    }),
                                tl: /* [] */0
                              }),
                          children: Curry._1(t, "SubmitIdentification_ContactBidsDepartment")
                        })), React.createElement("div", undefined, Belt_Array.map(bidsDepartmentEmails, (function (email) {
                            return React.createElement(SubmitIdentificationModal$Pending$EmailInfoClicker, {
                                        info: email
                                      });
                          })))), React.createElement(SterlingModal$LiveRoom.Footer.make, {
                  children: React.createElement(Button.Button, {
                        onClick: (function (param) {
                            Curry._1(onClose, undefined);
                          }),
                        className: Curry._1(Css.style, {
                              hd: Css.maxWidth(Css.px(135)),
                              tl: /* [] */0
                            }),
                        children: Curry._1(t, "Common_close")
                      })
                }));
}

var Pending = {
  EmailInfoClicker: EmailInfoClicker,
  make: SubmitIdentificationModal$Pending
};

function SubmitIdentificationModal(props) {
  var saleNumber = props.saleNumber;
  var modalType = props.modalType;
  var onClose = props.onClose;
  if (modalType === 1) {
    return React.createElement(SubmitIdentificationModal$Pending, {
                onClose: onClose
              });
  }
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  var infoText;
  switch (modalType) {
    case /* FirstTime */2 :
    case /* Rejected */3 :
        infoText = Curry._1(t, "SubmitIdentification_FirstTime");
        break;
    case /* Expired */4 :
        infoText = Curry._1(t, "SubmitIdentification_Expired");
        break;
    case /* Success */0 :
    case /* Pending */1 :
    case /* Error */5 :
        infoText = "";
        break;
    
  }
  return React.createElement(SterlingModal$LiveRoom.Modal.make, {
              children: null,
              className: Curry._1(Css.style, {
                    hd: Css.maxHeight(Css.pct(100)),
                    tl: {
                      hd: CommonStyles$LiveRoom.mediaV2(/* Desktop */0, {
                            hd: Css.maxWidth(Css.px(724)),
                            tl: /* [] */0
                          }),
                      tl: /* [] */0
                    }
                  }),
              onClose: onClose,
              isOpen: true,
              headerTitle: Curry._1(t, "SubmitIdentification_SubmitYourIdentification")
            }, React.createElement(SterlingModal$LiveRoom.Content.make, {
                  children: React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
                        children: infoText
                      })
                }), React.createElement(SterlingModal$LiveRoom.Footer.make, {
                  children: null,
                  className: Curry._1(Css.style, {
                        hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                              hd: Css.display("flex"),
                              tl: {
                                hd: Css.important(Css.flexDirection("columnReverse")),
                                tl: {
                                  hd: Css.alignItems("center"),
                                  tl: /* [] */0
                                }
                              }
                            }),
                        tl: /* [] */0
                      })
                }, React.createElement(Button.Button, {
                      onClick: (function (param) {
                          Curry._1(onClose, undefined);
                        }),
                      className: Curry._1(Css.style, {
                            hd: CommonStyles$LiveRoom.mediaV2(/* DesktopAndTabletLandscape */4, {
                                  hd: Css.important(Css.width(Css.px(178))),
                                  tl: /* [] */0
                                }),
                            tl: /* [] */0
                          }),
                      buttonStyle: "secondary",
                      children: Curry._1(t, "MaybeLater")
                    }), React.createElement(Button.Button, {
                      onClick: (function (param) {
                          AuthTokenHook$LiveRoom.triggerTransactionalUpgrade({
                                auctionFlow: true,
                                origin: /* SaleRegistration */1,
                                saleNumber: saleNumber
                              }, {
                                showSelectAccount: true
                              }, Config$LiveRoom.values.transactionlUrl + "/how-to-upload-id");
                        }),
                      className: Curry._1(Css.style, {
                            hd: CommonStyles$LiveRoom.mediaV2(/* DesktopAndTabletLandscape */4, {
                                  hd: Css.marginLeft(Css.px(16)),
                                  tl: {
                                    hd: Css.important(Css.width(Css.px(178))),
                                    tl: /* [] */0
                                  }
                                }),
                            tl: {
                              hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                                    hd: Css.marginBottom(Css.px(16)),
                                    tl: /* [] */0
                                  }),
                              tl: /* [] */0
                            }
                          }),
                      children: Curry._1(t, "UploadID")
                    })));
}

var make = SubmitIdentificationModal;

export {
  Pending ,
  make ,
}
/* Css Not a pure module */
